<template>
  <div class="form-links px-i">
    <div class="form-links-wrapper container-fluid">
      <div class="dropdown form-links-wrapper-dropdown">
        <a id="inputToggles"
           class="btn btn-primary dropdown-toggle ihjoz-dropdown-toggle"
           href="#"
           role="button"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
          Add & Remove
        </a>
        <div class="dropdown-menu form-toggles-dropdown" aria-labelledby="inputToggles">
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: subjectToggleClasses.active }" @click.prevent="toggleInput('subject')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-information form-toggles-dropdown-item-start-icon" />
              Subject
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="subjectToggleClasses.icon" />
            </div>
          </a>
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: descriptionToggleClasses.active }" @click.prevent="toggleInput('description')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-file-alt form-toggles-dropdown-item-start-icon" />
              Description
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="descriptionToggleClasses.icon" />
            </div>
          </a>
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: attachmentsToggleClasses.active }" @click.prevent="toggleInput('attachments')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-paperclip form-toggles-dropdown-item-start-icon" />
              Attachments
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="attachmentsToggleClasses.icon" />
            </div>
          </a>
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: lineItemsToggleClasses.active }" @click.prevent="toggleInput('lineItems')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-receipt-cog form-toggles-dropdown-item-start-icon" />
              Line Items
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="lineItemsToggleClasses.icon" />
            </div>
          </a>
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: notesToggleClasses.active }" @click.prevent="toggleInput('notes')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-sticky-note form-toggles-dropdown-item-start-icon" />
              Notes
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="notesToggleClasses.icon" />
            </div>
          </a>
          <a href="#" class="dropdown-item form-toggles-dropdown-item" :class="{ active: termsToggleClasses.active }" @click.prevent="toggleInput('conditions')">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-file-contract form-toggles-dropdown-item-start-icon" />
              Terms & Conditions
            </div>
            <div class="form-toggles-dropdown-item-end">
              <i class="demo-icon" :class="termsToggleClasses.icon" />
            </div>
          </a>
        </div>
      </div>
      <div class="dropdown form-links-wrapper-dropdown form-links-wrapper-dropdown-with-icon">
        <a id="templateSwitcher"
           class="btn btn-info dropdown-toggle ihjoz-dropdown-toggle"
           href="#"
           role="button"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
          <div class="form-links-wrapper-item-icon">
            <i class="demo-icon icon-receipt-cog"/>
          </div>
          <span>
            {{ usedTemplate.name }}
          </span>
        </a>
        <div class="dropdown-menu form-toggles-dropdown" aria-labelledby="templateSwitcher">
          <a v-for="template in voucherTemplates"
             :key="template.id"
             href="#"
             class="dropdown-item form-toggles-dropdown-item"
             :class="{ active: templateActive(template.id) }"
             @click.prevent="selectTemplate(template.id)">
            <div class="form-toggles-dropdown-item-start">
              <i class="demo-icon icon-receipt-cog form-toggles-dropdown-item-start-icon" />
              {{ template.name }}
            </div>
            <div v-if="templateActive(template.id)"
                 class="form-toggles-dropdown-item-end">
              <i class="demo-icon icon-check" />
            </div>
          </a>
        </div>
      </div>
      <button
        data-target="#invoice-preview-modal"
        data-toggle="modal"
        type="button"
        class="btn btn-info form-links-wrapper-item ihjoz-button"
        @click="previewInvoice">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-eye" />
        </div>
        <span class="form-links-wrapper-item-text">Preview</span>
      </button>
      <a v-if="showReset"
         href="#"
         class="btn btn-info ihjoz-button form-links-wrapper-item"
         @click.prevent="resetInfo()">
        <div class="form-links-wrapper-item-icon">
          <i class="demo-icon icon-sync-alt" />
        </div>
        <span class="form-links-wrapper-item-text">Reset</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Controls",

  props: {
    voucherTemplates: { type: Array },
    displayedComponents: { type: Object },
    usedTemplate: { type: Object }
  },

  data: function () {
    return {
      displayInfo: this.displayedComponents,
      showReset: false
    };
  },

  computed: {
    subjectToggleClasses () {
      return this.displayInfo.subject ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    },

    descriptionToggleClasses () {
      return this.displayInfo.description ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    },

    attachmentsToggleClasses () {
      return this.displayInfo.attachments ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    },

    lineItemsToggleClasses () {
      return this.displayInfo.lineItems ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    },

    notesToggleClasses () {
      return this.displayInfo.notes ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    },

    termsToggleClasses () {
      return this.displayInfo.conditions ? { active: true, icon: "icon-times" } : { active: false, icon: "icon-plus" };
    }
  },

  methods: {
    toggleInput (field) {
      this.$emit("displayChanged", field);
    },

    templateActive (id) {
      return id === this.usedTemplate.id;
    },

    selectTemplate (id) {
      this.showReset = true;

      this.$emit("templateChanged", id);
    },

    resetInfo () {
      this.showReset = false;

      this.$emit("resetInfo");
    },

    previewInvoice () {
      this.$emit("previewInvoice");
    }
  }
};
</script>
